import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HeadersTool} from '../tools/headers';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private route: string = '/agencies-links';

  constructor(
    private http: HttpClient
  ) { }

  public getAll(): Observable<any> {
    return this.http.get(`${environment.apiUrl}${this.route}`, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

  public getMy(): Observable<any> {
    return this.http.get(`${environment.apiUrl}${this.route}/me`, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

  updateClient(nrjID: string, powerBILink: string) {
    return this.http.put(`${environment.apiUrl}${this.route}/${nrjID}`, {
      powerbiLink: powerBILink,
    }, {
      headers: HeadersTool.getHeadersWithToken()
    })
  }
}
